export const UPDATE_ADDRESS_DEFAULT_SUCCESS = 'UPDATE_ADDRESS_DEFAULT_SUCCESS';
export const UPDATE_ADDRESS_DEFAULT_REQUEST = 'UPDATE_ADDRESS_DEFAULT_REQUEST';
export const UPDATE_ADDRESS_DEFAULT_FAILURE = 'UPDATE_ADDRESS_DEFAULT_FAILURE';
export const UPDATE_ADDRESS_DEFAULT_RESET = 'UPDATE_ADDRESS_DEFAULT_RESET';
export const updateAddressDefaultSuccess = (payload) => ({
    type: UPDATE_ADDRESS_DEFAULT_SUCCESS,
    payload,
});
export const updateAddressDefaultRequest = (payload) => ({
    type: UPDATE_ADDRESS_DEFAULT_REQUEST,
    payload,
});
export const updateAddressDefaultFailure = (payload) => ({
    type: UPDATE_ADDRESS_DEFAULT_FAILURE,
    payload,
});
export const updateAddressDefaultReset = () => ({
    type: UPDATE_ADDRESS_DEFAULT_RESET,
});
